<template>
  <CustomUpdateDialog
    dialogTitle="لیست کاربران کلاس گروهی"
    :dialogId="`group-class-users-list-${dialogId}`"
    okOnly
    okTitle="بستن"
    @ok="closeUsersListDialog"
  >
    <BCol cols="12" class="py-1">
      <ul>
        <li v-for="(student, index) in studentsList" :key="index" class="my-2">
          <div class="d-flex align-items-center">
            <b-link :to="`/master/users/${student.studentUserId}`">
              {{ student.studentUserFullName }}
            </b-link>
            <span class="mx-1">-</span>
            <a
              :href="`tel:${student.studentUserMobile}`"
              v-if="student.studentUserMobile"
            >
              {{ student.studentUserMobile }}
            </a>
          </div>
        </li>
      </ul>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    studentsList: {
      type: Array,
    },
    dialogId: {
      type: [String, Number],
    },
  },
  methods: {
    closeUsersListDialog() {
      this.$nextTick(() => {
        this.$bvModal.hide(`group-class-users-list-${this.dialogId}`);
      });
    },
  },
  components: {
    CustomUpdateDialog,
    BCol,
    BLink,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import { BCol, BLink } from "bootstrap-vue";
</script>
